import React, { useEffect, useState } from "react";
import { FaPlus, FaTrash, FaInfoCircle } from "react-icons/fa";
import { IoMdAddCircle } from "react-icons/io";
import SuperAppButton from "./SuperAppButton";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
  Select,
  MenuItem,
  IconButton,
  Tooltip as MuiTooltip,
  Box
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

let initialJsons = {
  tool_name: "order_pizza",
  tool_description:
    "Don't execute this function until you get confirmed from user about all of these [toping, size, name] are clear to you. If not then ask all of the details then execute this function.",
  action_type: {
    type: "result_api_payload",
    url: "http://127.0.0.1:7200/api/order_pizza",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    subApi: {
      type: "no_merge_with_params",
      method: "post",
      url: "",
      headers: {
        "Content-Type": "application/json",
      },
      params: {
        type: "object",
        parameters: [],
      },
    },
    params: {
      type: "object",
      parameters: [],
    },
  },
  response_object: {
    primary_path: "data",
    display_type: "text",
    parameters: [],
    custom_response: [],
  },
};

const defaultStructure = {
  "response_object.parameters": { displayName: "", path: "", display_type: "" },
  "action_type.parameters": { displayName: "", path: "", display_type: "" },
  "response_object.custom_response": {
    displayName: "",
    type: "text",
    value: "",
  },
  "action_type.params.parameters": {
    name: "key",
    path: "key",
    value: "",
  },
  "action_type.subApi.params.parameters": {
    name: "key",
    path: "key",
    value: "",
  },
};

const typeOptions = {
  text: ["displayName", "value"],
  number: ["displayName", "value"],
  button: ["displayName", "path"],
  form: [
    { displayName: "", path: "", display_type: "text" },
  ],
  ticket_card: [
    { displayName: "", path: "", display_type: "text" },
  ],
  parameters: {
    name: "key",
    path: "key",
    value: "",
  },
};

const displayTypeChildrens = {
  ticket_card: ["title", "card_body", "image", "subtitle", "header"],
};

const dropdownOption = {
  display_type: ["text", "ticket_card", "number", "button"],
  type: Object.keys(typeOptions),
};

const customDropdown = {
  "response_object.display_type": ["text", "ticket_card", "number", "button"],
  "action_type.method": ["GET", "POST", "PUT", "DELETE"],
  "action_type.subApi.method": ["GET", "POST", "PUT", "DELETE"],
  "action_type.type": ["result_api_payload", "result_api_call", "api"],
  "action_type.params.type": ["object", "array"],
  "action_type.params.subApi.type": ["object", "array"],
  "action_type.subApi.type": ["no_merge_with_params", "no_merge_with_payload"],
};

const DynamicJsonEditorV2 = ({
  dropdownOptions = dropdownOption,
  displayTypeChildren = displayTypeChildrens,
  typeOption = typeOptions,
  defaultStructures = defaultStructure,
  initialJson = initialJsons,
  customDropdowns = customDropdown,
  setListData,
  customTooltip = {},
  customName = {},
  fieldData = null,
  formData = null,
  sample_templates = null,
}) => {
  const [jsonData, setJsonData] = useState({});
  const [expanded, setExpanded] = useState({});
  const [newItemPath, setNewItemPath] = useState(null);

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded({ ...expanded, [panel]: isExpanded });
  };

  useEffect(() => {
    if (setListData) {
      if (formData?.sample_template && sample_templates?.length > 0) {
        let data = sample_templates?.find((item) => (item?.template_name == formData?.sample_template));
        let jsonData = data?.[fieldData?.name];
        // setListData(jsonData);
        setJsonData(jsonData);
      }
    }
  }, [formData?.sample_template, sample_templates]);

  useEffect(() => {
    if (initialJson) {
      setJsonData(initialJson);
    }
  }, []);
  
  useEffect(() => {
    if (jsonData) {
      setListData(jsonData);
    }
  }, [jsonData]);

  // Auto-expand the newly added item
  useEffect(() => {
    if (newItemPath) {
      setExpanded(prev => ({ ...prev, [newItemPath]: true }));
      setNewItemPath(null);
    }
  }, [newItemPath]);

  function getUpdatedValue(jsonData, parentKey) {
    let keys = parentKey.split(".");
    if (keys[keys.length - 1] === "0") {
      keys.pop();
    }
    return keys.reduce(
      (acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined),
      jsonData
    );
  }

  const updateJson = (path, value) => {
    setJsonData((prev) => {
      const newJson = JSON.parse(JSON.stringify(prev));
      const keys = path.split(".");
      let obj = newJson;

      for (let i = 0; i < keys.length - 1; i++) {
        if (!obj[keys[i]]) obj[keys[i]] = {};
        obj = obj[keys[i]];
      }

      obj[keys[keys.length - 1]] = value;

      if (path?.includes("custom_response") && keys[keys.length - 1] === "type") {
        const parentPath = keys.slice(0, -1).join(".");
        const parentObj = getObjectByPath(newJson, parentPath);
        if (typeof typeOption?.[value] == "object") {
          parentObj.value = typeOption?.[value];
        } else {
          parentObj.value = "";
        }
      }

      return newJson;
    });
  };

  const getObjectByPath = (obj, path) => {
    const keys = path.split(".");
    let current = obj;
    for (const key of keys) {
      if (current[key] === undefined) {
        current[key] = {};
      }
      current = current[key];
    }
    return current;
  };

  function replaceLastValue(parentKey, newValue = "type") {
    let keys = parentKey?.split(".");
    let newval = "";
    if (keys[keys.length - 2] == "value") {
      keys[keys.length - 2] = newValue;
      keys.pop();
      newval = keys.join(".");
    }
    return newval;
  }

  const handleAddItem = (path) => {
    setJsonData((prev) => {
      const newJson = JSON.parse(JSON.stringify(prev));
      const keys = path.split(".");
      let obj = newJson;

      if (keys[keys.length - 1] == "value") {
        const parentKeys = keys.slice(0, -1);
        const parentPath = parentKeys.join(".");
        const parentObj = getObjectByPath(newJson, parentPath);
        const parentType = parentObj.type;
        const newItemStructure = typeOptions[parentType][0] || {};
        
        let newItem;
        if (Array.isArray(newItemStructure)) {
          newItem = newItemStructure.reduce((acc, field) => {
            acc[field] = "";
            return acc;
          }, {});
        } else if (typeof newItemStructure === "object") {
          newItem = { ...newItemStructure };
        } else {
          newItem = {};
        }

        if (!Array.isArray(parentObj.value)) parentObj.value = [];
        const newIndex = parentObj.value.length;
        parentObj.value.push(newItem);
        
        // Set the path for the new item to be expanded
        setNewItemPath(`${path}.${newIndex}`);
      } else {
        for (let i = 0; i < keys.length - 1; i++) {
          if (!obj[keys[i]]) obj[keys[i]] = {};
          obj = obj[keys[i]];
        }
        if (!Array.isArray(obj[keys[keys.length - 1]]))
          obj[keys[keys.length - 1]] = [];
        const newIndex = obj[keys[keys.length - 1]].length;
        obj[keys[keys.length - 1]].push(
          defaultStructures[path] ? { ...defaultStructures[path] } : {}
        );
        
        // Set the path for the new item to be expanded
        setNewItemPath(`${path}.${newIndex}`);
      }

      return newJson;
    });
  };

  const handleDeleteItem = (path, index) => {
    setJsonData((prev) => {
      const newJson = JSON.parse(JSON.stringify(prev));
      const keys = path.split(".");
      let obj = newJson;

      for (let i = 0; i < keys.length - 1; i++) {
        if (!obj[keys[i]]) return prev;
        obj = obj[keys[i]];
      }

      if (Array.isArray(obj[keys[keys.length - 1]])) {
        obj[keys[keys.length - 1]].splice(index, 1);
      }

      return newJson;
    });
  };

  const renderForm = (data, parentKey = "", parentDisplayType = null) => {
    return Object.entries(data).map(([key, value]) => {
      const path = parentKey ? `${parentKey}.${key}` : key;
      const normalizePath = (path) => path?.replace(/\.\d+/g, '[]')?.replace(/\[(\d+)\]/g, '[]');
      const normalizedPath = normalizePath(path);
      const customNameValue = customName[normalizedPath] || key;
      const tooltip = customTooltip[normalizedPath] || null;
      const options = customDropdowns[path] || null;
      const accordionId = `accordion-${path}`;

      if (Array.isArray(value)) {
        return (
          <Accordion
            key={path}
            expanded={expanded[accordionId] || false}
            onChange={handleAccordionChange(accordionId)}
            sx={{ 
              mb: 1, 
              bgcolor: 'transparent',
              '&:before': {
                display: 'none'
              }
            }}
          >
            <AccordionSummary 
              expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
              sx={{
                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                borderRadius: '4px',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.3)'
                }
              }}
            >
              <Typography sx={{ 
                color: 'white', 
                display: 'flex', 
                alignItems: 'center',
                fontWeight: '500'
              }}>
                {customNameValue} ({value.length} items)
                {tooltip && (
                  <MuiTooltip title={tooltip}>
                    <IconButton size="small" sx={{ ml: 1 }}>
                      <FaInfoCircle fontSize="small" color="#2196F3" />
                    </IconButton>
                  </MuiTooltip>
                )}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ pt: 1, pl: 2, pr: 0 }}>
              <Box sx={{ ml: 1, }}>
                {value.map((item, index) => {
                  const itemPath = `${path}.${index}`;
                  return (
                    <Accordion
                      key={itemPath}
                      expanded={expanded[itemPath] || false}
                      onChange={handleAccordionChange(itemPath)}
                      sx={{ 
                        mb: 1,
                        bgcolor: 'transparent',
                        '&:before': {
                          display: 'none'
                        }
                      }}
                    >
                      <AccordionSummary 
                        expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
                        sx={{
                          backgroundColor: 'rgba(0, 0, 0, 0.1)',
                          borderRadius: '4px',
                          minHeight: '48px !important',
                          '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.2)'
                          }
                        }}
                      >
                        <Box sx={{ 
                          display: 'flex', 
                          justifyContent: 'space-between', 
                          width: '100%',
                          alignItems: 'center'
                        }}>
                          <Typography sx={{ color: 'white' }}>Item {index + 1}</Typography>
                          <IconButton 
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDeleteItem(path, index);
                            }}
                            size="small"
                            sx={{ 
                              mr: 1,
                              color: 'rgba(255, 255, 255, 0.7)',
                              '&:hover': {
                                color: 'white'
                              }
                            }}
                          >
                            <FaTrash fontSize="small" />
                          </IconButton>
                        </Box>
                      </AccordionSummary>
                      <AccordionDetails sx={{ pt: 1, pl: 2, pr: 0 }}>
                        {renderForm(item, itemPath, data.display_type || parentDisplayType)}
                      </AccordionDetails>
                    </Accordion>
                  );
                })}
                <div style={{marginTop: '10px'}}>

                <SuperAppButton
                  onClick={() => handleAddItem(path)}
                  startIcon={<IoMdAddCircle />}
                  size="small"
                  
                >
                  Add item
                </SuperAppButton>
                </div>
              </Box>
            </AccordionDetails>
          </Accordion>
        );
      } else if (typeof value === "object" && value !== null) {
        return (
          <Accordion
            key={path}
            expanded={expanded[accordionId] || false}
            onChange={handleAccordionChange(accordionId)}
            sx={{ 
              mb: 1, 
              bgcolor: 'transparent',
              '&:before': {
                display: 'none'
              }
            }}
          >
            <AccordionSummary 
              expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
              sx={{
                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                borderRadius: '4px',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.3)'
                }
              }}
            >
              <Typography sx={{ 
                textTransform: 'capitalize', 
                display: 'flex', 
                alignItems: 'center',
                color: 'white',
                fontWeight: '500'
              }}>
                {customNameValue}
                {tooltip && (
                  <MuiTooltip title={tooltip}>
                    <IconButton size="small" sx={{ ml: 1 }}>
                      <FaInfoCircle fontSize="small" color="#2196F3" />
                    </IconButton>
                  </MuiTooltip>
                )}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ pt: 1, pl: 2, pr: 0 }}>
              {renderForm(value, path, data.display_type || parentDisplayType)}
            </AccordionDetails>
          </Accordion>
        );
      }

      return (
        <Box 
          key={path} 
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            mb: 2, 
            gap: 2,
            pl: 1
          }}
        >
          <Typography 
            variant="body2" 
            sx={{ 
              minWidth: 120, 
              textTransform: 'capitalize',
              color: 'white'
            }}
          >
            {customNameValue}
            {tooltip && (
              <MuiTooltip title={tooltip}>
                <IconButton size="small" sx={{ ml: 1 }}>
                  <FaInfoCircle fontSize="small" color="#2196F3" />
                </IconButton>
              </MuiTooltip>
            )}
          </Typography>
          {options && !parentKey?.includes("custom_response") ? (
            <Select
              value={value || ''}
              onChange={(e) => updateJson(path, e.target.value)}
              size="small"
              fullWidth
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                '& .MuiSelect-select': {
                  color: 'white'
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(255, 255, 255, 0.23)'
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(255, 255, 255, 0.5)'
                }
              }}
            >
              <MenuItem value=""></MenuItem>
              {options.map((option) => (
                <MenuItem 
                  key={option} 
                  value={option}
                  sx={{ color: 'black' }}
                >
                  {option}
                </MenuItem>
              ))}
            </Select>
          ) : key === "type" && parentKey?.includes("custom_response") ? (
            <Select
              value={value || ''}
              onChange={(e) => updateJson(path, e.target.value)}
              size="small"
              fullWidth
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                '& .MuiSelect-select': {
                  color: 'white'
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(255, 255, 255, 0.23)'
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(255, 255, 255, 0.5)'
                }
              }}
            >
              <MenuItem value=""></MenuItem>
              {Object.keys(typeOption).map((option) => (
                <MenuItem 
                  key={option} 
                  value={option}
                  sx={{ color: 'black' }}
                >
                  {option}
                </MenuItem>
              ))}
            </Select>
          ) : key === "display_type" && parentKey?.includes("custom_response") ? (
            <Select
              value={value || ''}
              onChange={(e) => updateJson(path, e.target.value)}
              size="small"
              fullWidth
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                '& .MuiSelect-select': {
                  color: 'white'
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(255, 255, 255, 0.23)'
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(255, 255, 255, 0.5)'
                }
              }}
            >
              <MenuItem value=""></MenuItem>
              {displayTypeChildren[
                getUpdatedValue(jsonData, replaceLastValue(parentKey))
              ]?.map((option) => (
                <MenuItem 
                  key={option} 
                  value={option}
                  sx={{ color: 'black' }}
                >
                  {option}
                </MenuItem>
              ))}
            </Select>
          ) : (
            <TextField
              value={value || ''}
              onChange={(e) => updateJson(path, e.target.value)}
              size="small"
              fullWidth
              variant="outlined"
              sx={{
                '& .MuiInputBase-root': {
                  color: 'white',
                  '& fieldset': {
                    borderColor: 'rgba(255, 255, 255, 0.23)'
                  },
                  '&:hover fieldset': {
                    borderColor: 'rgba(255, 255, 255, 0.5)'
                  }
                },
                '& .MuiInputBase-input': {
                  py: 1
                }
              }}
            />
          )}
        </Box>
      );
    });
  };

  return (
    <Box sx={{ p: 2 }}>
      {renderForm(jsonData)}
    </Box>
  );
};

export default DynamicJsonEditorV2;

const Tooltip = ({ text, children }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div
      style={{ position: "relative", display: "inline-block" }}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {children}
      {showTooltip && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: "50%",
            transform: "translateX(-50%)",
            background: "#333",
            color: "white",
            padding: "5px 10px",
            borderRadius: "4px",
            zIndex: 1,
            whiteSpace: "nowrap",
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
};